export enum AnimateState {
    Default,

    Search,
    SearchToCourts,
    SearchToSearchCalendarProgress,
    SearchToSearchCalendar,
    SearchToSearchFilter,

    SearchCalendar,
    SearchCalendarToSearchProgress,
    SearchCalendarToSearch,

    SearchFilter,
    SearchFilterToSearch,

    Courts,
    CourtsToSearch,
    CourtsToPlayers,
    CourtsToCourtsCalendarProgress,
    CourtsToCourtsCalendar,
    CourtsToCourtsFilter,

    CourtsCalendar,
    CourtsCalendarToCourtsProgress,
    CourtsCalendarToCourts,

    CourtsFilter,
    CourtsFilterToCourts,

    Players,
    PlayersToPlayers,
    PlayersToCourts,
    PlayersToPlayersCalendarProgress,
    PlayersToPlayersCalendar,
    PlayersToPlayersFilter,

    PlayersCalendar,
    PlayersCalendarToPlayersProgress,
    PlayersCalendarToPlayers,

    PlayersFilter,
    PlayersFilterToPlayers,
}
